/* Vyrox21 — Auto-swap PDP image al cambio colore matchando alt/filename */
(function() {
  'use strict';

  function normalize(s) {
    return (s || '').toLowerCase()
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, ' ').trim();
  }

  function findMatchingMedia(colorValue) {
    var colorNorm = normalize(colorValue);
    if (!colorNorm) return null;
    // Search media gallery by alt or src
    var mediaItems = document.querySelectorAll('.product-card__image-picture, .product-media-gallery img, [data-product-media] img, .product-media img, .pdp-media img, .product__media img');
    for (var i = 0; i < mediaItems.length; i++) {
      var img = mediaItems[i];
      var alt = normalize(img.getAttribute('alt') || '');
      var src = normalize(img.getAttribute('src') || '');
      if (alt.indexOf(colorNorm) !== -1 || src.indexOf(colorNorm) !== -1) {
        return img;
      }
    }
    return null;
  }

  function scrollToMedia(img) {
    if (!img) return;
    img.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
    // Pulse animation
    img.style.transition = 'box-shadow 600ms';
    img.style.boxShadow = '0 0 0 4px var(--v21-gold, #c9a96e)';
    setTimeout(function(){ img.style.boxShadow = 'none'; }, 1200);
  }

  function onVariantChange(e) {
    var changed = e.target;
    if (!changed) return;
    // Find color option button/radio
    var labelText = '';
    if (changed.tagName === 'BUTTON' || changed.tagName === 'INPUT') {
      // Look in parent variant-picker for color option label
      var fieldset = changed.closest('fieldset, [data-option-name]');
      if (fieldset) {
        var optionName = (fieldset.querySelector('legend, [data-option-label]') || {}).textContent || '';
        if (/colore|color/i.test(optionName)) {
          labelText = changed.value || changed.textContent || changed.getAttribute('aria-label') || '';
        }
      }
    }
    if (!labelText) {
      // Generic: use changed text content
      labelText = changed.textContent || changed.value || '';
    }
    var matched = findMatchingMedia(labelText);
    if (matched) scrollToMedia(matched);
  }

  function init() {
    // Listen on variant-picker clicks/changes
    document.addEventListener('click', function(e) {
      var t = e.target.closest('[data-option-value], variant-picker button, variant-picker input, .variant-picker__option');
      if (t) {
        setTimeout(function(){ onVariantChange({ target: t }); }, 50);
      }
    });
    document.addEventListener('change', function(e) {
      if (e.target.matches('input[type="radio"], select')) {
        onVariantChange(e);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
